import styled, { css } from 'styled-components';

import {
    spaceMixin,
    token,
    mediaMixin,
} from '@zillow/constellation';

import {
    HR,
} from '@zillow/zrs-comet';

export const StyledContainer = styled.div`
    /* 769 */
    ${mediaMixin('lg', css`
        padding: ${spaceMixin(0.5)} 0;
    `)}
`;

export const StyledHR = styled(HR)`
    /* override */
    /* margin: 16px 0 20px 0; */
    color: ${token('colors.gray300')};

    &:before,
    &:after {
        background: ${token('colors.gray300')};
    }
`;

export const StyledWithSubTitleHeader = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: space-between;
    align-items: baseline;
`;

export const StyledSubTitleAndIcon = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;

    .Subtitle {
        margin-right: ${spaceMixin('xs')};
    }
`;
